export const NOTIFICATION_REMINDER = 1;
export const NOTIFICATION_IMPORT_LEADS = 2;
export const NOTIFICATION_LEAD_ASSIGNMENT = 3;
export const NOTIFICATION_BULK_LEAD_ASSIGNMENT = 4;

export const NOTIFICATION_IMPORT_LEADS_SUCCEED = "Succeed";
export const NOTIFICATION_IMPORT_LEADS_FAILED = "Failed";